export const generateAMTableCellDataTestId = ({
  itemKey,
}: {
  itemKey: string;
}) => {
  const [year, quarter, month, dataType] = itemKey.split("|");
  return `${year}${quarter ? `-q${quarter}` : ""}${month ? `-m${month}` : ""}-${dataType}`.toLowerCase();
};
